import {Button, Grid, Stack, styled} from '@mui/material'

export const CustomButton = styled(Button)(() => ({
  margin: '0.44rem',
}))

export const ModalContentWrapper = styled(Stack)(() => ({
  alignItems: 'center',
  columnGap: 15,
  flexDirection: 'row',
}))

export const ButtonWrapper = styled(Grid)(() => ({display: 'flex', alignItems: 'flex-end'}))
